import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";

import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return true;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return true;
        } else {
            return true;
        }
    }
}
class AxisAggrMaster extends Component{
    constructor(props) {
        super(props);
        this.state ={
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            loading:false,
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,

            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            model_visible : false,
            file_url: '',
            rfile: '',
        }
        this.close = this.close.bind(this);
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidUpdate() {
        const { listOpen } = this.state;
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
            this.get_axis_aggr_stores(decoded.object_type,arrayCode,'');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })

        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            setTimeout(function(){
                this.get_axis_aggr_stores(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            setTimeout(function(){
                this.get_axis_aggr_stores(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,

            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            setTimeout(function(){
                this.get_axis_aggr_stores(decoded.object_type,arrayCode,'');
            }.bind(this), 200);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }

        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });

    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }


    get_axis_aggr_stores(event) {
        var that = this;
        //disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
        };
        if ($.fn.DataTable.isDataTable('#AxisAggrTable')) {
            $('#AxisAggrTable').DataTable().clear().destroy();
        }
        var AxisAggrTable = $('#AxisAggrTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/users/axis-aggr-master",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [
                    {"data":"merchant_name", "width":"100px"},
                    {"data":"merchant_code", "width":"100px"},
                    {"data":"chain_name", "width":"100px"},
                    {"data":"chain_code", "width":"100px"},
                    {"data":"store_name"},
                    {"data":"store_code"},
                                    ],
                "columnDefs": [
//                     {  render: function (data) {
//                             return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
//                         },
//                         "width": "80px",
//                         "targets": 6
//                     },

                ],

            });

    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = [{value:'', label: 'Select'}]
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }

        });
    }

    changeMerchant(login_type, optionSelected){
//         let value='';
//         let midArray = [];
//         if(optionSelected.length<1){
//             value = null;
//             midArray = '';
//         }
//         else{
//             optionSelected.map((mids, i) => {
//                 midArray.push(mids.value)
//                 if (login_type != 'merchant') {
//                     var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
//                     this.state.merchantList.move(index, 0).join(',');
//                 }
//             });
//         }
        const value = optionSelected === null ? '' : optionSelected.value;
        let midArray = [];
        if(value===null || value===""){
            midArray = ""
        } else {
            midArray.push(value)
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
        });
        // this.get_axis_aggr_stores(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.txnIds, this.state.txnTypeIDs, '', this.state.isSettledIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }


    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            ciutidIds: '',
            ciutidValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }

    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            is_chain_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    addStore(action, e){
        if(this.state.merchantID==='' && this.state.chainID==="" && this.state.storeID==="") {
            alert("Please select merchant")
            return false;
        }
        axios.post(config.get('API_URL')+'/users/add-axis-store/',{
                merchant_code: this.state.merchantID,
                chain_code: this.state.chainID,
                store_code: this.state.storeID,
                action:action
             },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
             console.log("resssss", response)
             this.get_axis_aggr_stores();
             if(response.data.error==null || response.data.error=="null" || response.data.error=="") {
                alert(response.data.data)
             } else {
                alert(response.data.error)
             }
        });
    }
    downLoadAxisMaster (e){

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/users/axis-aggr-master-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            // xhrFields: {
            //     responseType: 'blob'
            // },
            success: function (response, status, xhr) {
                this.copyFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    copyFile (remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'axis_aggregator_master.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };

        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Axis Aggregator Master</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">

                                        {this.state.merchant_list_box ===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Merchants</label>
                                                <Select name="merchants"
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="merchantLists"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this,'')}
                                                options={this.state.merchantList}
                                            // defaultValue={{ label: "Select", value: '' }}
                                                placeholder="All"
                                        />


                                                <div className="clearfix"></div>
                                            </div> : null}
                                        {this.state.chain_list_box===true?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Chain </label>
                                                <ReactMultiSelectCheckboxes name="chain"
                                                    isMulti
                                                                            isLoading={this.state.is_chain_loading}
                                                    components={{ MenuList }}
                                                    value={this.state.chainValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeChain.bind(this,'')}
                                                    options={this.state.chainList}
                                                    placeholderButtonLabel="Select [Chain]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>: null }
                                        {this.state.store_list_box===true?
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Store: </label>
                                                <div className="dd-wrapper">
                                                    <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                        {this.state.storeID==''?
                                                            <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                            <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                        }

                                                        <i className="fa fa-angle-down"></i>
                                                    </div>
                                                    {this.state.storeListOpen ===true?
                                                        <div
                                                            role="list"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="dd-list-search-bar"
                                                                placeholder="Search"
                                                                onChange={(e) => this.storeFilterList(e)}
                                                            />
                                                            <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                            {/*<div className="dd-scroll-list">*/}
                                                            <ul className="dd-list">
                                                                {this.state.is_store_loading===true?
                                                                    <li>
                                                                        <BeatLoader
                                                                            css={override}
                                                                            sizeUnit={"px"}
                                                                            size={5}
                                                                            color={'#666666'}
                                                                            loading={this.state.is_store_loading}
                                                                        />
                                                                    </li>: null}
                                                                {store_lists}

                                                            </ul> </div>: null }
                                                    {/*</div>*/}
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>: null }
                                            <div className="col-md-2"><br/>
                                                <button type="button" className="primary apply-filter" role="button"  onClick={this.addStore.bind(this,'add')}>Add New Store</button>
                                            </div>
                                            <div className="col-md-2"><br/>
                                                <button type="button" className="primary reset-filter" role="button"  onClick={this.addStore.bind(this,'delete')}>Delete</button>
                                            </div>

                                    </div>

                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadAxisMaster.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="AxisAggrTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="100px">Merchant Name</th>
                                                    <th width="100px">Merchant Code</th>
                                                    <th>Chain Name</th>
                                                    <th>Chain Code</th>
                                                    <th>Store Name</th>
                                                    <th>Store Code</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV…</p>:<p>Fetching File. Please wait…</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>

                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( AxisAggrMaster );